import React, { useState, useEffect } from 'react';
import './AddCommentForm.css'; // Assume this CSS file is for styling your component
import { FeedbackMessage } from '../../elements/FeedbackMessage/FeedbackMessage'; // Import the new component

const AddCommentForm = ({ onSubmit, placeholder, maxLength = 500 }) => {
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const [commentText, setCommentText] = useState('');
  const [charactersLeft, setCharactersLeft] = useState(maxLength);

  useEffect(() => {
    // Update the characters left as the user types
    setCharactersLeft(maxLength - commentText.length);
  }, [commentText, maxLength]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (commentText.trim() === '') {
      setFeedbackMessage('Your comment cannot be empty!');
      return;
    }
    onSubmit(commentText);
    setCommentText('');
  };

  return (
    <form onSubmit={handleSubmit} className="commentForm">
      <textarea
        id="commentTextarea"
        className="commentTextarea"
        value={commentText}
        onChange={(e) => setCommentText(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        aria-describedby="commentFeedback"
      />
      <div className='feedbackAndButtonContainer'>
        <button type="submit" className="submitButton">Submit</button>
        <div id="commentFeedback" className="commentFeedback">
          {charactersLeft} characters left
        </div>
      </div>
      <FeedbackMessage message={feedbackMessage} onClear={() => setFeedbackMessage('')} />
    </form>
  );
};

export default AddCommentForm;
